////////LIBRARY/////////
import React, { useEffect, useState } from 'react'
import { useRouteMatch } from 'react-router'
import styled from 'styled-components'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
///////COMPONENTS///////
import ArticleDatePicker from '../ArticleDatePicker'
import { articleLifeManagerActionCreators } from '../../../../../store/actions'

/////////STYLED/////////
const ModalModifyScheduledActivateActionWrapper = styled.div``
/////////STYLED/////////
//[63]_k): MODIFY SCHEDULED ACTIVATION ITEM

const ModalModifyScheduledActivateAction = (props) => {
	const match = useRouteMatch()

	const { translations, articleLifeManager } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			articleLifeManager: state.articleLifeManager,
		}),
		shallowEqual
	)

	const actionsArticleLifeManager = bindActionCreators(articleLifeManagerActionCreators, useDispatch())

	const [dateToModify, setDateToModify] = useState(new Date())

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleChangeDate = (date) => {
		setDateToModify(date)
	}

	const handleValidate = () => {
		actionsArticleLifeManager.updateScheduledActivateAction(match.params.id, 'ModifyScheduledActivateAction', dateToModify)
		handleCloseDatePicker()
	}

	const handleCloseDatePicker = () => {
		props.action.close()
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (props.action?.item?.dateToModify) if (props.action.show) handleChangeDate(new Date(props.action.item.dateToModify))
	}, [props.action.show])

	useEffect(() => {
		if (articleLifeManager?.isUpdate) props.action.close()
	}, [articleLifeManager?.isUpdate])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<ModalModifyScheduledActivateActionWrapper>
			<ArticleDatePicker
				showModal={props.action.show}
				date={dateToModify}
				handleValidate={handleValidate}
				handleClose={handleCloseDatePicker}
				handleChangeDate={handleChangeDate}
				title={translations['modal__itemRef__timeline_action_activation_scheduled_title']}
				priorLimit={props?.action?.item?.dateLimit}
			/>
		</ModalModifyScheduledActivateActionWrapper>
	)
}

ModalModifyScheduledActivateAction.propTypes = {}

ModalModifyScheduledActivateAction.defaultPropTypes = {}

export default ModalModifyScheduledActivateAction
